export default __webpack_public_path__ + "static/media/5-gm-achieved_old.86a2a216.svg";